import api from '../../../../_metronic/helpers/api'

const API_URL = import.meta.env.VITE_BACKEND_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/users/my-details`
export const LOGIN_URL = `${API_URL}/users/auth/login`

// Server should return AuthModel
// export function login(email: string, password: string) {
//   return api.post<any>(LOGIN_URL, {
//     email,
//     password,
//   })
// }

export function getUserByToken(token: string) {
  return api.get<any>(GET_USER_BY_ACCESSTOKEN_URL
  )
}